export default __webpack_public_path__ + "static/media/icon-email-sent.743ad77e.svg";